import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_Teksti_Tilaus({ subText, keikkaState }) {
  return (
    <GridKeikkaEditor_Teksti_Row title="Tilaus" gray>
      {subText("Tilausnumero: " + keikkaState?.keikkaId)}
    </GridKeikkaEditor_Teksti_Row>
  );
}
GridKeikkaEditor_Teksti_Tilaus.propTypes = {
  subText: PropTypes.func,
  keikkaState: PropTypes.object,
};
